import { useTranslate } from '@festina-life/ui/hooks'
import type { PropsWithChildren } from 'react'

import { useAvailableComponents } from '../../../hooks/useAvailableComponents'
import { useComponent, useHook } from '../../../lenteHooks'
import { IdToPerson } from '../../idToLec/IdToPerson'
import { OverviewItem } from '../../overview/OverviewItem'
import { OverviewSection } from '../../overview/OverviewSection'
import { withLegalEntityOrLife } from '../../wrappers/withLegalEntityOrLife'
import { BirthOrDeathDate } from './BirthOrDeathDate'
import { BirthOrDeathDateFromCommitmentVersion } from './BirthOrDeathDateFromCommitmentVersion'
import { MemberIcon } from './MemberIcon'
import { ParticipantSectionLayout } from './ParticipantSectionLayout'

type Props = PropsWithChildren

const ParticipantSectionInternal = ({ children }: Props) => {
  const translate = useTranslate()
  const { isUsingLegalEntity } = useAvailableComponents()
  const { ownerId } = useHook('routing.general.useEntityParams')()
  const RelationshipInfo = useComponent(
    'pages.commitment.general.RelationshipInfo',
  )
  const NameAndDeathStatus = useComponent(
    'pages.commitment.general.NameAndDeathStatus',
  )

  return (
    <ParticipantSectionLayout
      MemberIcon={MemberIcon}
      NameAndDeathStatus={NameAndDeathStatus}
    >
      <OverviewSection>
        <OverviewItem
          iconName="Identification"
          title={translate('participantSection.ssn')}
          hasCopyButton
        >
          <IdToPerson id={ownerId} format="externalId" link="never" />
        </OverviewItem>
        {isUsingLegalEntity ? (
          <BirthOrDeathDate />
        ) : (
          <BirthOrDeathDateFromCommitmentVersion />
        )}
        <RelationshipInfo />
      </OverviewSection>
      {children}
    </ParticipantSectionLayout>
  )
}

export const ParticipantSection = withLegalEntityOrLife(
  ParticipantSectionInternal,
)
